module.exports = __webpack_public_path__ + "static/turtle-creek-house38-6b0ea1dd30b9f30a950a3c042fc32481.jpg";